import React, {useRef, useContext} from 'react';
import {Card, ListGroup, Dropdown} from 'react-bootstrap';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import Graph from './Graph';
import {useNavigate} from 'react-router';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
import { MadricContext } from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @return {JSX}
 */
function Checkin(props) {

  const navigate = useNavigate();
  const {setWhatToShow} = useContext(MadricContext);


  return (
    <div className="checkin-container" key={props.checkin.id}>
    <Card className="checkin-card">
      <Card.Header className="checkin-header">
        <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>CHECK-IN</span>  {props.formatDate(props.checkin.date)}
        <button style={{marginLeft:"5px"}} className="checkin-pagination-button float-end" onClick={() => {setWhatToShow('2'); navigate('/chantier/'+ props.checkin.place_id)}}><FontAwesomeIcon icon={faArrowRight} /></button>
      </Card.Header>
      <ListGroup variant="flush">
      <ListGroup.Item className="checkin-list-item" style={{fontWeight:"bold", fontSize:"18px"}}>
          {props.checkin.user_name}
        </ListGroup.Item>
      <ListGroup.Item className="checkin-list-item">
          Projet: {props.checkin.place_name}
        </ListGroup.Item>

        <ListGroup.Item
          className="checkin-list-item"
          style={{
            backgroundColor:
            props.checkin.from === null || props.checkin.to === null ? 'red' : 'white',
          }}
        >
          Heure: {props.checkin.from === null ? '-' : props.checkin.from} à{' '}
          {props.checkin.to === null ? '-' : props.checkin.to}
        </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
          Transport: {props.checkin.transport === 1 ? 'Oui' : 'Non'}
        </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
          Travaillé avec:
          {props.checkin.work_with.length === 0 ? (
            ' Aucun employé'
          ) : (
            <Dropdown>
              <Dropdown.Toggle
                className="chantierheure-dropdown"
                style={{
                  all: 'unset',
                  backgroundColor: 'white',
                  color: 'black',
                  cursor: 'pointer',
                }}
              >
                {props.checkin.work_with[0].label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {props.checkin.work_with.map((w, index) => {
                  return <Dropdown.Item key={index}>{w.label}</Dropdown.Item>;
                })}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </ListGroup.Item>
        <ListGroup.Item>
          <MDBCheckbox
            name="extra1"
            id="inlineCheckbox111"
            defaultChecked={props.checkin.extra1}
            label="Extra possible"
            disabled
            inline
          />
          {localStorage.getItem('admin') === '1' ? (
            <React.Fragment>
              <MDBCheckbox
                name="extra2"
                id="inlineCheckbox222"
                defaultChecked={props.checkin.extra2}
                disabled
                label="Extra valider"

                inline
              />
              <MDBCheckbox
                name="extra3"
                id="inlineCheckbox333"
                defaultChecked={props.checkin.extra3}
                label="Extra confirmer"
                disabled
                inline
              />
            </React.Fragment>
          ) : (
            ' '
          )}
        </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
          Note: {props.checkin.note}
        </ListGroup.Item>
      </ListGroup>
      {props.checkedGraph ? props.checkin.taches.length !== 0 ? <Card.Body> <Graph taches={props.checkin.taches}/></Card.Body>  : '' : ''}
    </Card>
  </div>
  );
}

export default Checkin;